// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3LWKA","list":"PatternAutocomplete_list__3zojC"};